const guard = {
  'administration-users': ['Admin', 'User_View', 'User_Review', 'User_Manage'],
  beneficiary: ['Admin', 'Beneficiary_View', 'Beneficiary_Review'],
  'beneficiaries-load': ['Admin', 'Beneficiary_Load'],
  'beneficiaries-allotment': ['Admin', 'Beneficiary_Review'],
  administrator: ['Admin'],
};

export const navigationGuard = Object.freeze(guard);
